import Modernizr from 'modernizr';

export const transEndEventName = (function () {
    return {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd',
        msTransition: 'MSTransitionEnd',
        transition: 'transitionend'
    }[Modernizr.prefixed( 'transition' )];
})();

export const transStartEventName = (function () {
    return {
        WebkitTransition: 'webkitTransitionStart',
        MozTransition: 'transitionStart',
        OTransition: 'oTransitionStart',
        msTransition: 'MSTransitionStart',
        transition: 'transitionstart'
    }[Modernizr.prefixed( 'transition' )];
})();

export const animEndEventName = (function () {
    return {
        WebkitAnimation: 'webkitAnimationEnd',
        MozAnimation: 'animationend',
        OAnimation: 'oAnimationEnd',
        msAnimation: 'MSAnimationEnd',
        animation: 'animationend'
    }[Modernizr.prefixed( 'animation' )];
})();

export const animStartEventName = (function () {
    return {
        WebkitAnimation: 'webkitAnimationStart',
        MozAnimation: 'animationStart',
        OAnimation: 'oAnimationStart',
        msAnimation: 'MSAnimationStart',
        animation: 'animationstart'
    }[Modernizr.prefixed( 'animation' )];
})();